import MevrisLocalDeviceController from '@mevris/device-controller-mevris-local';
import MevrisRemoteDeviceController from '@mevris/device-controller-mevris-remote';

export const deviceControllers = {
	MevrisLocalDeviceController,
	MevrisRemoteDeviceController,
};
